export enum ThemeEnum {
  CLASSIC = 'CLASSIC',
  SIMS = 'SIMS',
  SPACE = 'SPACE',
  MINECRAFT = 'MINECRAFT',
  GTA = 'GTA',
}
